import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  /**
   * App title
   *
   * @memberof AppComponent
   */
  public title = 'Eidos 4.0';
}
